import cloneDeep from 'lodash.clonedeep';
import { AwaitResponse } from '@general/js/utils/MockUtils';
import { mpCoverDetails, MemberPolicies } from '@/constants/MyCoverServicesMockApiData';
import { MemberDetails } from '@/constants/MemberDetailsMockApiData';
import AbstractClass from './MemberDetailsAbstractServices';

export default class MemberDetailsServices extends AbstractClass {
  /**
   * Return mock data of member details ref data
   */
  static getMemberDetailsPageReferenceData() {
    const mockData = {
      nameHelpText: {
        informationText:
          '<p>The information displayed here is not editable. Please <a href="/portal/$memberNumber$/Support/Contact-Us" tabindex="0">contact us</a> if something doesn&rsquo;t look right.</p>\r\n',
      },
      memberDetailsInformationText: {
        informationText:
          '<p>Manage the details for this member. Remember that a change in personal details may impact the premium and/or eligibility for a product. ​</p>\r\n\r\n<p>​If something does not look right, or you need assistance, please&nbsp;<a href="/$memberNumber$/Support/Contact-Us" target="_blank">contact us</a>.​</p>\r\n',
      },
      titleRankOptions: [
        {
          display: 'Second Lieutenant',
          returnValue: '2LT',
        },
        {
          display: 'Able Seaman',
          returnValue: 'AB',
        },
        {
          display: 'Aircraftman',
          returnValue: 'AC',
        },
        {
          display: 'Air Cadet',
          returnValue: 'ACDT',
        },
        {
          display: 'Air Chief Marshal',
          returnValue: 'ACM',
        },
        {
          display: 'Aircraftman Recruit',
          returnValue: 'ACR',
        },
        {
          display: 'Aircraftwoman',
          returnValue: 'ACW',
        },
        {
          display: 'Admiral',
          returnValue: 'ADML',
        },
        {
          display: 'Air Commodore',
          returnValue: 'AIRCDRE',
        },
        {
          display: 'Air Marshal',
          returnValue: 'AIRMSHL',
        },
        {
          display: 'Apprentice',
          returnValue: 'APP',
        },
        {
          display: 'Acting Sub Lieutenant',
          returnValue: 'ASLT',
        },
        {
          display: 'Air Vice Marshal',
          returnValue: 'AVM',
        },
        {
          display: 'Bombardier',
          returnValue: 'BDR',
        },
        {
          display: 'Brigadier',
          returnValue: 'BRIG',
        },
        {
          display: 'Captain',
          returnValue: 'CAPT',
        },
        {
          display: 'Captain RAN',
          returnValue: 'CAPTN',
        },
        {
          display: 'Commodore',
          returnValue: 'CDRE',
        },
        {
          display: 'Cadet',
          returnValue: 'CDT',
        },
        {
          display: 'Craftsman',
          returnValue: 'CFN',
        },
        {
          display: 'Chaplain',
          returnValue: 'CHAP',
        },
        {
          display: 'Commander',
          returnValue: 'CMDR',
        },
        {
          display: 'Colonel',
          returnValue: 'COL',
        },
        {
          display: 'Corporal',
          returnValue: 'CPL',
        },
        {
          display: 'Chief Petty Officer',
          returnValue: 'CPO',
        },
        {
          display: 'Flying Officer',
          returnValue: 'FLGOFF',
        },
        {
          display: 'Flight Lieutenant',
          returnValue: 'FLTLT',
        },
        {
          display: 'Flight Sergeant',
          returnValue: 'FSGT',
        },
        {
          display: 'General',
          returnValue: 'GEN',
        },
        {
          display: 'Gunner',
          returnValue: 'GNR',
        },
        {
          display: 'Group Captain',
          returnValue: 'GPCAPT',
        },
        {
          display: 'Leading Aircraftman',
          returnValue: 'LAC',
        },
        {
          display: 'Leading Aircraftwoman',
          returnValue: 'LACW',
        },
        {
          display: 'Lance Bombardier',
          returnValue: 'LBDR',
        },
        {
          display: 'Lieutenant Commander',
          returnValue: 'LCDR',
        },
        {
          display: 'Lance Corporal',
          returnValue: 'LCPL',
        },
        {
          display: '(LEUT) Lieutenant',
          returnValue: 'LEUT',
        },
        {
          display: 'Leading Seaman',
          returnValue: 'LS',
        },
        {
          display: '(LT) Lieutenant',
          returnValue: 'LT',
        },
        {
          display: 'Lieutenant Colonel',
          returnValue: 'LTCOL',
        },
        {
          display: 'Lieutenant General',
          returnValue: 'LTGEN',
        },
        {
          display: 'Major',
          returnValue: 'MAJ',
        },
        {
          display: 'Major General',
          returnValue: 'MAJGEN',
        },
        {
          display: 'Midshipman',
          returnValue: 'MIDN',
        },
        {
          display: 'Musician',
          returnValue: 'MUSN',
        },
        {
          display: 'Officer Cadet',
          returnValue: 'OCDT',
        },
        {
          display: 'Ordinary Seaman',
          returnValue: 'ORD',
        },
        {
          display: 'Principal Chaplain',
          returnValue: 'PCHA',
        },
        {
          display: 'Pilot Officer',
          returnValue: 'PLTOFF',
        },
        {
          display: 'Petty Officer',
          returnValue: 'PO',
        },
        {
          display: 'Private',
          returnValue: 'PTE',
        },
        {
          display: 'Rear Admiral',
          returnValue: 'RADM',
        },
        {
          display: 'Recruit',
          returnValue: 'REC',
        },
        {
          display: 'Regimental Sergeant Major',
          returnValue: 'RSM-A',
        },
        {
          display: 'Sub Lieutenant',
          returnValue: 'SBLT',
        },
        {
          display: 'Senior Chaplain',
          returnValue: 'SCHA',
        },
        {
          display: 'AAA',
          returnValue: 'SGT',
        },
        {
          display: 'Signalman',
          returnValue: 'SIG',
        },
        {
          display: 'Seaman',
          returnValue: 'SMN',
        },
        {
          display: 'Sapper',
          returnValue: 'SPR',
        },
        {
          display: 'Squadron Leader',
          returnValue: 'SQNLDR',
        },
        {
          display: 'Staff Sergeant',
          returnValue: 'SSGT',
        },
        {
          display: 'Trooper',
          returnValue: 'TPR',
        },
        {
          display: 'Vice Admiral',
          returnValue: 'VADM',
        },
        {
          display: 'Wing Commander',
          returnValue: 'WGCDR',
        },
        {
          display: '(WO) Warrant Officer',
          returnValue: 'WO',
        },
        {
          display: '(WO1) Warrant Officer Class 1',
          returnValue: 'WO1',
        },
        {
          display: '(WO2) Warrant Officer Class 2',
          returnValue: 'WO2',
        },
        {
          display: '(WOFF) Warrant Officer',
          returnValue: 'WOFF',
        },
        {
          display: 'Doctor',
          returnValue: 'DR',
        },
        {
          display: 'Lady',
          returnValue: 'LADY',
        },
        {
          display: 'Miss',
          returnValue: 'MISS',
        },
        {
          display: 'Mr',
          returnValue: 'MR',
        },
        {
          display: 'Mrs',
          returnValue: 'MRS',
        },
        {
          display: 'Ms',
          returnValue: 'MS',
        },
        {
          display: 'Professor',
          returnValue: 'PROF',
        },
        {
          display: 'Reverend',
          returnValue: 'REV',
        },
        {
          display: 'Sir',
          returnValue: 'SIR',
        },
        {
          display: 'Master',
          returnValue: 'MASTER',
        },
        {
          display: 'Sister',
          returnValue: 'SR',
        },
      ],
      sex: {
        label: null,
        helpText: '<p>We collect biological sex to support claims processes​</p>\r\n',
        options: [
          {
            display: 'Male',
            returnValue: 'M',
          },
          {
            display: 'Female',
            returnValue: 'F',
          },
        ],
      },
      coveredOnMembershipOptions: [
        {
          display: 'Policy Holder',
          returnValue: 'MEMBR',
        },
        {
          display: 'Spouse',
          returnValue: 'SPS',
        },
        {
          display: 'Other (Adult) Dependant',
          returnValue: 'OTHER',
        },
        {
          display: 'Defacto',
          returnValue: 'DFCT',
        },
        {
          display: 'Ex Spouse',
          returnValue: 'EXSP',
        },
        {
          display: 'Daughter',
          returnValue: 'DTR',
        },
        {
          display: 'Son',
          returnValue: 'SON',
        },
        {
          display: 'Foster Child',
          returnValue: 'FCHLD',
        },
        {
          display: 'Grand Child',
          returnValue: 'GCHD',
        },
        {
          display: 'Baby',
          returnValue: 'BABY',
        },
        {
          display: 'Step Son',
          returnValue: 'STPS',
        },
        {
          display: 'Step Daughter',
          returnValue: 'STPD',
        },
      ],
      residentialAddressHelpText: {
        informationText:
          '<p>When updating your address, selecting a different state may result in a change to your premium. You will be advised of any premium changes upon submitting this update.</p>\r\n',
      },
      residentialAddressFullAccessHelpText: {
        informationText: '<p>Residential address can only be updated from the policy holder&rsquo;s member details.</p>\r\n',
      },
      postalAddressHelpText: {
        informationText: 'Placeholder content',
      },
      contactInformationAlertText: {
        informationText: 'We are having difficulty contacting you. Please ensure your contact details are up to date.',
      },
      mobileAccountSecurityHelpText: {
        informationText:
          'Your mobile number is linked to your account security. To update your details, visit <a href="/MemberPortal/GetRequestAccountManagement" target="_blank">Account security</a>',
      },
      mobileAccountSecurityOtherMemberHelpText: {
        informationText: 'This mobile number for this member is managed through their Account Security and can only be updated by the account holder.',
      },
      emailAccountSecurityHelpText: {
        informationText:
          'Your email address is linked to your account security. To update your details, visit <a href="/MemberPortal/GetRequestAccountManagement" target="_blank">Account security</a>',
      },
      emailAccountSecurityOtherMemberHelpText: {
        informationText: 'This email address for this member is managed through their Account Security and can only be updated by the account holder.',
      },
      preferredCommunicationOptions: [
        {
          display: 'Email',
          returnValue: 'EMAIL',
        },
        {
          display: 'Post',
          returnValue: 'POST',
        },
      ],
      preferredCommunicationHelpText: {
        informationText: 'This will be where we will send any communications related to your policy.',
      },
      paymentAdviceOptions: [
        {
          display: 'Yes',
          returnValue: true,
        },
        {
          display: 'No',
          returnValue: false,
        },
      ],
      paymentAdviceHelpText: {
        informationText:
          'When you submit a claim with us, we will deposit any benefits into your nominated bank account. You can view a record of those in your&nbsp;<a href="/$memberNumber$/">claim history</a>.',
      },
      keepPrivateHelpText: {
        informationText:
          '<p>By&nbsp;<a href="/$memberNumber$/Support/HelpHQ">enabling privacy</a>, other members on this policy cannot view or edit your personal information. Privacy is only maintained when it is enabled. When disabled all information, current and historic will be visible to other members on this policy.</p>\r\n\r\n<p>If you enable privacy, please ensure your contact details are up to date.</p>\r\n',
      },
      policyPermissionInformationText: {
        informationText: 'Policy permissions regulate what each member can view or change on this membership.',
      },
      policyPermissionOptions: [
        {
          display: 'Full access',
          returnValue: 'Full Access',
        },
        {
          display: 'Self access',
          returnValue: 'Self Access',
        },
      ],
      policyPermissionHelpText: {
        informationText:
          'Check out&nbsp;<a href="/$memberNumber$/Support/Health-HQ">Health HQ&nbsp;</a>for more information on policy access permissions and what they mean for you and your family.',
      },
      studentDeclarationHelpText: {
        informationText: `<p>If your student status changes throughout the year, you will need to &nbsp;<a href="/$memberNumber$/Support/Contact-Us" target="_blank">contact us&nbsp;</a></p>\r\n
          <p>If you’re no longer studying, single and under 31 talk to your family about our <a href="/" target="_blank">Family+</a> options to keep you covered.</p>\r\n`,
      },
      studentDeclarationInformationText: {
        informationText: `<p>If you are a full-time student, you can remain on the family cover until you turn 31.</p>\r\n
          <p>Complete this declaration as soon as you turn 21 if you are still studying, and each year you continue to study until you turn 31.</p>\r\n
          <p>Make sure you complete your declaration by 1 March each year, or you may be removed from the policy.</p>\r\n`,
      },
      veteranCardWhiteOptions: [
        {
          display: 'Alcohol Dependence & Abuse',
          returnValue: 'DVAC2',
        },
        {
          display: 'Ankle',
          returnValue: 'DVAC1',
        },
        {
          display: 'Arm/Hand',
          returnValue: 'DVACD',
        },
        {
          display: 'Back',
          returnValue: 'DVAC7',
        },
        {
          display: 'Cancer (Malignant Neoplasm)',
          returnValue: 'DVAC4',
        },
        {
          display: 'Cardiac',
          returnValue: 'DVAC5',
        },
        {
          display: 'Hearing Loss/Tinnitus',
          returnValue: 'DVAC6',
        },
        {
          display: 'Hip',
          returnValue: 'DVACB',
        },
        {
          display: 'Knee',
          returnValue: 'DVACA',
        },
        {
          display: 'Mental Health Conditions',
          returnValue: 'DVAC3',
        },
        {
          display: 'Neck',
          returnValue: 'DVACC',
        },
        {
          display: 'Osteoarthritis',
          returnValue: 'DVAC8',
        },
        {
          display: 'Other',
          returnValue: 'DVACO',
        },
        {
          display: 'PTS Disorder',
          returnValue: 'DVAC9',
        },
        {
          display: 'Shoulder',
          returnValue: 'DVAC0',
        },
        {
          display: 'Pulmonary Tuberculosis',
          returnValue: 'DVACE',
        },
      ],
      veteranCardGoldInformationText: {
        informationText: 'Private Health Insurance is not generally required in addition to a Veteran Gold Card.&nbsp;<a href="/error/not-found" target="_blank">Learn more</a>.​​',
      },
      veteranCardTypeOptions: [
        {
          display: 'Veteran Gold Card',
          returnValue: 'Veteran Gold Card',
        },
        {
          display: 'Veteran White Card',
          returnValue: 'Veteran White Card',
        },
      ],
      veteranCardWhiteInformationText: {
        informationText:
          '<p>By providing your Veteran Card details, you agree to claim eligible benefits for conditions covered on your card through the Department of Veterans&rsquo; Affairs first. ​</p><p>Using the search below, select all the accepted service-related conditions that are listed as covered by your Veteran White Card. If a condition is not listed, please select other.</p>',
      },
      veteranCardHelpText: {
        informationText: `Adding or removing a Veteran Card may impact your premium.&nbsp;<a href="/error/not-found" target="_blank">Learn more</a>.`,
      },
      eligibilityInformationText: {
        informationText:
          '<p>Here&rsquo;s what we have recorded as your eligibility to join Defence Health.</p>\r\n\r\n<p>For members joining, leaving or adjusting service status with the ADF, it is important that you let us know so we can ensure you receive the most suitable products for your needs. For most members, eligibility will not change.</p>\r\n',
      },
      eligibilityEditingInformationText: {
        informationText:
          '<p>When updating your eligibility,&nbsp;selecting a different eligibility may result in&nbsp;a change to your premium or your ability to hold a specific product.&nbsp;You will be advised of any&nbsp;premium or product changes required upon&nbsp;submitting this update.</p>',
      },
      eligibilitySummaryInformationText: {
        informationText:
          '<p>Updating your eligibility may result in a change to your premium or your ability to hold a specific product. You will be advised of any premium or product changes required upon submitting this update.</p>',
      },
      needsAnalysisEligibilityOptions: [
        {
          display: 'I/My partner is currently serving',
          returnValue: 'ADF',
        },
        {
          display: 'I/My partner has served',
          returnValue: 'ExServing',
        },
        {
          display: 'I/My partner is related to someone who is eligible to join',
          returnValue: 'Supporting',
        },
        {
          display: 'I/My partner work for a Defence company or Dept of Defence',
          returnValue: 'WorkConnection',
        },
      ],
      serviceConnectionOptions: [
        {
          display: 'Self',
          returnValue: 'Self',
        },
        {
          display: 'Partner',
          returnValue: 'Partner',
        },
      ],
      serviceTypeOptions: [
        {
          display: 'Permanent',
          returnValue: 'Permanent',
        },
        {
          display: 'Reservist',
          returnValue: 'Reservist',
        },
      ],
      serviceAgencyOptions: [
        {
          display: 'Navy',
          returnValue: 'Navy',
        },
        {
          display: 'Air Force',
          returnValue: 'Air Force',
        },
        {
          display: 'Army',
          returnValue: 'Army',
        },
      ],
      serviceConnectionRelationshipOptions: [
        {
          display: 'Child',
          returnValue: 'Child',
        },
        {
          display: 'Parent',
          returnValue: 'Parent',
        },
        {
          display: 'Grandparent',
          returnValue: 'Grandparent',
        },
        {
          display: 'Brother or Sister',
          returnValue: 'Brother or Sister',
        },
        {
          display: 'Former partner',
          returnValue: 'Former partner',
        },
      ],
      sercat: {
        label: 'SERCAT status - 3, 4, 5, 6 or 7',
        helpText: '',
        options: [
          {
            display: 'SERCAT 3',
            returnValue: '3',
          },
          {
            display: 'SERCAT 4',
            returnValue: '4',
          },
          {
            display: 'SERCAT 5',
            returnValue: '5',
          },
          {
            display: 'SERCAT 6',
            returnValue: '6',
          },
          {
            display: 'SERCAT 7',
            returnValue: '7',
          },
        ],
      },
      sercatHelpText: {
        informationText:
          'It&rsquo;s our honour to serve ADF personnel and that&rsquo;s why we have exclusive offers for you.&nbsp; Providing evidence that confirms your service category ensures you can access special products and discounts.',
      },
      eligibilityWorkedForOptions: [
        {
          display: 'Contractor',
          returnValue: 'Contractor',
        },
        {
          display: 'Defence Public Service',
          returnValue: 'Work for department',
        },
      ],
      eligibilityOptions: [
        {
          display: 'Currently serving',
          returnValue: 'Currently serving',
        },
        {
          display: 'Ex-serving',
          returnValue: 'Ex-serving',
        },
        {
          display: 'Contractor',
          returnValue: 'Contractor',
        },
        {
          display: 'Defence Public Service',
          returnValue: 'Defence Public Service',
        },
      ],
      concessionCardInformationText: {
        informationText: 'Our records indicate that you might be entitled to a concession card.',
      },
      concessionCardAdditionalFieldsHelpText: {
        informationText:
          'By keeping us updated as to whether you hold one of these cards ensures we are not paying for services that you are already entitled to, which helps us keep premiums more affordable.​',
      },
      concessionCardWithoutAdditionalFieldsHelpText: {
        informationText: '<p>Concession cards include Pensioner Concession Card, Commonwealth Seniors Health Card or Health Care Card.</p>\r\n',
      },
      concessionCardExpiryWarningText: {
        informationText:
          '<p>Our records indicate that your concession card details may have expired. Please update the concession card details, or remove the card(s) if it&#39;s no longer valid.</p>\r\n',
      },
      concessionCardOptions: [
        {
          display: 'Commonwealth Seniors Health Card',
          returnValue: 'CSHC',
        },
        {
          display: 'Health Care Card',
          returnValue: 'HCC',
        },
        {
          display: 'Pensioner Concession Card',
          returnValue: 'PCC',
        },
        {
          display: 'Veterans Service Pension Card',
          returnValue: 'VSPC',
        },
      ],
      concessionCardAdditionalInformationAlertText: {
        informationText:
          '<p>Please review the concession card details and update if required. Changing State or type of cover may change the information we can hold about concession cards.</p>\r\n',
      },
      concessionCardDeclarationAlertText: {
        informationText:
          '<p>Please review the concession card details and update if required. Changing State may change the information we can hold about concession cards.</p>\r\n',
      },
      concessionCardAdditionalInformationAltAlertText: {
        informationText: '<p>Please obtain concession card details. Changing State may change the information we can hold about concession cards.</p>\r\n',
      },
      concessionCardTurning65AlertText: {
        informationText: '<p>Please confirm if you hold a concession card.</p>\r\n',
      },
    };
    return AwaitResponse(JSON.parse(JSON.stringify(mockData).tokenSwap()));
  }

  /**
   * Return a mock data of member details.
   */
  static getMemberDetails() {
    const data = cloneDeep(MemberDetails);

    return AwaitResponse(data);
  }

  static getMemberships() {
    return AwaitResponse({
      firstName: 'Elaine',
      productList: [
        {
          memberNumber: 'WOD2014',
          productName: 'Everyday Hospital Bronze Plus',
          coveredOnMembership: 'Policy Holder',
          isExtras: false,
          extrasOnly: false,
        },
        {
          memberNumber: 'BC2007',
          productName: 'Value Extras',
          coveredOnMembership: 'Policy Holder',
          isExtras: true,
          extrasOnly: false,
        },
      ],
    });
  }

  /**
   * Return a mock data member selection page content
   */
  static getMemberSelectionContents() {
    const mockData = {
      memberSelectionInformationText: {
        informationText:
          '<p>Manage person details like contact information, privacy and membership&nbsp;access.</p>\r\n\r\n<p>Please note that a change in these details may impact the premium and/or eligibility for a product.&nbsp;</p>\r\n\r\n<p>If you need assistance,&nbsp;<a href="/$memberNumber$/Support/Contact-Us" target="_blank">contact us</a>.</p>\r\n',
      },
      memberSelectionCalloutText: {
        informationText:
          '<h2><strong>Keep your membership details up to date</strong></h2>\r\n\r\n<p>Take a few moments to make sure we can get in touch by checking your:</p>\r\n\r\n<ul>\r\n\t<li>Communication preferences</li>\r\n\t<li>Phone number</li>\r\n\t<li>Email address</li>\r\n</ul>\r\n',
      },
      relatedArticle1: {
        heading: 'How do I choose hospital cover?',
        toUrl: 'https://healthhq.defencehealth.com.au/2019/04/30/how-do-i-choose-hospital-cover/',
        imageUrl: 'https://healthhq.defencehealth.com.au/wp-content/uploads/2019/04/How-do-I-choose-hospital-cover-1024x683.jpg',
        imageAltText: 'family image',
        tag: 'Family',
        listedTime: '2021-08-18T14:02:57',
      },
      relatedArticle2: {
        heading: 'Keeping your cover affordable',
        toUrl: 'https://healthhq.defencehealth.com.au/2016/02/19/keeping-your-cover-affordable/',
        imageUrl: 'https://healthhq.defencehealth.com.au/wp-content/uploads/2016/02/Lady-on-Laptop-affordability-resized-1024x683.jpg',
        imageAltText: 'person on laptop',
        tag: 'Affordable',
        listedTime: '2021-08-18T14:03:35',
      },
      relatedArticle3: {
        heading: 'Make the most out of your health care',
        toUrl: 'https://healthhq.defencehealth.com.au/2016/08/31/make-health-care/',
        imageUrl: 'https://healthhq.defencehealth.com.au/wp-content/uploads/2016/08/Image-Benefits-of-PHI.jpg',
        imageAltText: 'hospital',
        tag: 'Wellness',
        listedTime: '2021-08-18T14:03:37',
      },
    };
    return AwaitResponse(JSON.parse(JSON.stringify(mockData).tokenSwap()));
  }

  /**
   * Return a mock data of members under selected membership.
   */
  static getMembers() {
    return AwaitResponse([
      {
        firstName: 'Seven',
        lastName: 'Puddy',
        accessLevel: 'Self Access',
        coveredOnMembership: 'Son',
        keepPrivateflag: false,
        personCode: 'Member-1006',
      },
      {
        firstName: 'David',
        lastName: 'Puddy',
        accessLevel: 'Full Access',
        coveredOnMembership: 'Spouse',
        keepPrivateflag: false,
        personCode: 'Member-100200000000',
      },
      {
        firstName: 'Elaine',
        lastName: 'Benes',
        accessLevel: 'Policy Holder Access',
        coveredOnMembership: 'Policy holder',
        keepPrivateflag: false,
        personCode: 'Member-1002',
      },
    ]);
  }

  /**
   * Return response for member details update.
   */
  static postMemberDetails() {
    return AwaitResponse({
      currentPremiumAmount: 20.0, // currentPremiumAmount: 15, - uncomment to enable testing of Premium Impact page
      newPremiumAmount: 20.0,
    });
  }

  static getNoImpactPageReferenceData() {
    const mockData = {
      noImpactInformationText: {
        informationText: '<p>The changes you have made can be viewed in <a href="/$memberNumber$/member-selection">Member Details</a>.</p>',
      },
      relatedPage1: {
        heading: 'Make a claim',
        description: 'Fast online claims for most extras services',
        toUrl: '/portal/$memberNumber$/my-claims/benefit-quotes/get-a-benefit-quote',
        imageUrl: 'https://healthhq.defencehealth.com.au/wp-content/uploads/2019/04/How-do-I-choose-hospital-cover-1024x683.jpg',
        imageAltText: 'image',
      },
      relatedPage2: {
        heading: 'Extras limits and usage',
        description: 'Check your limits and how much you can claim',
        toUrl: '/portal/$memberNumber$/my-claims/my-limits-and-usage',
        imageUrl: 'https://healthhq.defencehealth.com.au/wp-content/uploads/2016/02/Lady-on-Laptop-affordability-resized-1024x683.jpg',
        imageAltText: 'image',
      },
      relatedPage3: {
        heading: 'Time for a cover check?',
        description: 'Make sure you’ve got the right cover for your needs',
        toUrl: '/portal/$memberNumber$/my-cover/change-my-cover',
        imageUrl: 'https://healthhq.defencehealth.com.au/wp-content/uploads/2016/08/Image-Benefits-of-PHI.jpg',
        imageAltText: 'image',
      },
    };

    return AwaitResponse(JSON.parse(JSON.stringify(mockData).tokenSwap()));
  }

  static getPremiumImpactPageReferenceData() {
    const mockData = {
      premiumImpactTitle: {
        informationText: 'Your Member Details update was successful',
      },
      premiumImpactSubtitle: {
        informationText: '<p>The changes you have made can be viewed in&nbsp;your <a href="/portal/$memberNumber$/Member-Selection">Member Details</a>.</p>\r\n<br />\r\n&nbsp;',
      },
      premiumImpactCardTitle: {
        informationText: 'Your updated premium information',
      },
      premiumImpactCardParagraph: {
        informationText: 'Your premium has been updated based on your changes.',
      },
      premiumImpactRelatedArticle1: {
        heading: 'The joys of raising a guide dog puppy',
        toUrl: '/Support/Health-HQ/2019/November/The-joys-of-raising-a-Guide-Dog-puppy',
        imageUrl: '~/getmedia/4a1f9458-497e-4452-9922-f9bd54c93366/dog.jpg?width=719&height=730&ext=.jpg',
        imageAltText: 'The joys of raising a Guide Dog puppy',
        tag: 'Member Updates',
        listedTime: '2024-06-06T00:00:00',
      },
      premiumImpactRelatedArticle2: {
        heading: 'What involved in raising a puppy?',
        toUrl: '/Support/Health-HQ/2019/November/What-involved-in-raising-a-puppy',
        imageUrl: '~/getmedia/4a1f9458-497e-4452-9922-f9bd54c93366/dog.jpg?width=719&height=730&ext=.jpg',
        imageAltText: 'What’s involved in raising a puppy?',
        tag: 'Lifestyle',
        listedTime: '2019-10-30T00:00:00',
      },
    };
    return AwaitResponse(JSON.parse(JSON.stringify(mockData).tokenSwap()));
  }

  static getCoverDetails() {
    return AwaitResponse(mpCoverDetails);
  }

  static getMemberPolicies() {
    return AwaitResponse(MemberPolicies);
  }
}
